import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";
import Footer from "../../Include/Footer";
import Header from "../../Include/Header";
import Sidebar from "../../Include/Sidebar";
import PageHeader from "../../Components/PageHeader/PageHeader";
import { V_URL } from "../../../../BaseUrl";
import { getProject } from "../../../../Store/Store/Project/Project";

const MasterReport = () => {
    const dispatch = useDispatch();

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [, setSearch] = useState("");
    const [, setDownloading] = useState(false);
    const [limit, setLimit] = useState(10);

    const [filter, setFilter] = useState({
        startDate: "2026-08-01",
        endDate: "2026-09-03",
        projects: [],
    });

    // Fetch projects for filter dropdown
    useEffect(() => {
        dispatch(getProject());
    }, [dispatch]);

    const projectData = useSelector((state) => state?.getProject?.user?.data);

    const projectOptions = useMemo(() => {
        if (!projectData || !Array.isArray(projectData)) return [];
        return projectData.map((p) => {
            const cleanNo = (p.project_no || "").replace(/^[,\s]+|[,\s]+$/g, "").trim();
            return {
                label: cleanNo ? `${p.name} (${cleanNo})` : p.name,
                value: p._id,
            };
        });
    }, [projectData]);

    // Excel Download Handler
    const handleDownloadExcel = async () => {
        try {
            setDownloading(true);
            const payload = {
                firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
                year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
                start_date: filter.startDate || moment().startOf("month").format("YYYY-MM-DD"),
                end_date: filter.endDate || moment().format("YYYY-MM-DD"),
                project_ids: Array.isArray(filter.projects)
                    ? filter.projects
                    : filter.projects
                    ? [filter.projects]
                    : [],
            };

            const res = await axios.post(`${V_URL}/prosafe/pro-master-report-xlsx`, payload, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            if (res?.data?.success && res?.data?.data?.url) {
                window.open(res.data.data.url, "_blank");
                toast.success(res?.data?.message || "Master Report Excel downloaded successfully");
            } else {
                toast.error(res?.data?.message || "Failed to generate Excel report");
            }
        } catch (err) {
            console.error("handleDownloadExcel error:", err);
            toast.error(err?.response?.data?.message || "Error generating Excel report");
        } finally {
            setDownloading(false);
        }
    };

    const handleRefresh = () => {
        setFilter({
            startDate: moment().startOf("month").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            projects: [],
        });
        setSearch("");
    };

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
    };

    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const breadCrumbs = [
        { label: "Dashboard", link: "/main-store/user/dashboard" },
        { label: "Reports" },
        { label: "Master Report" },
    ];

    const filterConfig = [
        {
            key: "startDate",
            label: "Start Date",
            type: "date",
            value: filter.startDate,
            placeholder: "Select Start Date",
            colClass: "col-md-6 col-lg-3 mb-3",
        },
        {
            key: "endDate",
            label: "To Date",
            type: "date",
            value: filter.endDate,
            placeholder: "Select To Date",
            colClass: "col-md-6 col-lg-3 mb-3",
        },
        {
            key: "projects",
            label: "Filter Projects",
            type: "multiselect",
            value: filter.projects || [],
            options: projectOptions,
            placeholder: "All Projects (or select)",
            colClass: "col-md-6 col-lg-4 mb-3",
        },
    ];

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card card-table show-entire">
                                <div className="card-body">
                                    <PageHeader
                                        title="Master Report"
                                        breadcrumbs={breadCrumbs}
                                        onSearch={(val) => setSearch(val)}
                                        onRefresh={handleRefresh}
                                        filter={filter}
                                        onFilterChange={handleFilterChange}
                                        limit={limit}
                                        onLimitChange={(val) => setLimit(val)}
                                        filterConfig={filterConfig}
                                        onDownload={handleDownloadExcel}
                                        defaultFilterOpen={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default MasterReport;
